"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHeading = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const ProductHeading = (props) => {
    const { title } = props;
    return (react_1.default.createElement(styles_1.StyledProductHeading, { bold: true, headingLevel: 2, font: "medium" }, title));
};
exports.ProductHeading = ProductHeading;
